import { callable } from '../callable';

export interface AuditSectionDto {
  id: string;
  courseCode: string;
  courseName: string;
  termId: string | null;
  termName: string | null;
  status: string;
  startDate: string | null;
}

export interface AuditRowDto {
  personId: string;
  fullName: string;
  email: string | null;
  enrolledCount: number;
  totalActive: number;
  missing: Array<{ sectionId: string; courseCode: string; courseName: string }>;
  droppedOrInvalid: Array<{ sectionId: string; courseCode: string; status: string }>;
}

export interface AuditProgramEnrollmentsResult {
  program: { id: string; name: string };
  sections: AuditSectionDto[];
  droppedNoiseSections: number;
  rows: AuditRowDto[];
  skippedGhosts: number;
  perSectionMissing: Array<{
    sectionId: string;
    courseCode: string;
    courseName: string;
    missingCount: number;
  }>;
}

export const dataAuditApi = {
  runProgramAudit: async (data: {
    tenantId: string;
    programId: string;
    includeNoise?: boolean;
  }): Promise<AuditProgramEnrollmentsResult> => {
    const fn = callable<typeof data, AuditProgramEnrollmentsResult>('auditProgramEnrollments');
    return (await fn(data)).data;
  },
};
